/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: pricing.fga
 * Run: pnpm run gen:permissions -- pricing
 */

import type { ModulePermissions } from './types';

export const pricingPermissions = {
  module: 'pricing',
  displayName: 'Pricing',
  entities: [
    {
      name: 'counterpartyGroup',
      displayName: 'Counterparty Group',
      permissions: [
        { key: 'counterpartyGroupRead', action: 'Read', category: 'crud' },
        { key: 'counterpartyGroupCreate', action: 'Create', category: 'crud' },
        { key: 'counterpartyGroupUpdate', action: 'Update', category: 'crud' },
        { key: 'counterpartyGroupDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'counterpartyGroupMember',
      displayName: 'Counterparty Group Member',
      permissions: [
        {
          key: 'counterpartyGroupMemberRead',
          action: 'Read',
          category: 'crud',
        },
      ],
    },
    {
      name: 'customPriceList',
      displayName: 'Custom Price List',
      permissions: [
        { key: 'customPriceListRead', action: 'Read', category: 'crud' },
        { key: 'customPriceListCreate', action: 'Create', category: 'crud' },
        { key: 'customPriceListUpdate', action: 'Update', category: 'crud' },
        { key: 'customPriceListDelete', action: 'Delete', category: 'crud' },
        {
          key: 'customPriceListArchive',
          action: 'Archive',
          category: 'custom',
        },
        {
          key: 'customPriceListPublish',
          action: 'Publish',
          category: 'custom',
        },
      ],
    },
    {
      name: 'defaultPriceList',
      displayName: 'Default Price List',
      permissions: [
        { key: 'defaultPriceListRead', action: 'Read', category: 'crud' },
        { key: 'defaultPriceListUpdate', action: 'Update', category: 'crud' },
      ],
    },
    {
      name: 'itemPriceConfiguration',
      displayName: 'Item Price Configuration',
      permissions: [
        { key: 'itemPriceConfigurationRead', action: 'Read', category: 'crud' },
        {
          key: 'itemPriceConfigurationUpdate',
          action: 'Update',
          category: 'crud',
        },
      ],
    },
    {
      name: 'variable',
      displayName: 'Variable',
      permissions: [
        { key: 'variableRead', action: 'Read', category: 'crud' },
        { key: 'variableCreate', action: 'Create', category: 'crud' },
        { key: 'variableUpdate', action: 'Update', category: 'crud' },
        { key: 'variableDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Pricing module
 */
export type PricingPermissionKey =
  | 'counterpartyGroupRead'
  | 'counterpartyGroupCreate'
  | 'counterpartyGroupUpdate'
  | 'counterpartyGroupDelete'
  | 'counterpartyGroupMemberRead'
  | 'customPriceListRead'
  | 'customPriceListCreate'
  | 'customPriceListUpdate'
  | 'customPriceListDelete'
  | 'customPriceListArchive'
  | 'customPriceListPublish'
  | 'defaultPriceListRead'
  | 'defaultPriceListUpdate'
  | 'itemPriceConfigurationRead'
  | 'itemPriceConfigurationUpdate'
  | 'variableRead'
  | 'variableCreate'
  | 'variableUpdate'
  | 'variableDelete';
